module.exports = __webpack_public_path__ + "img/student-setting.51787a86.png";